import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Tabs, Tab, Box } from '@mui/material';
import {ReactComponent as Sidebar_settings} from '../Layer_images/Settings_images/sidebar-setting.svg'
import {ReactComponent as Google_maps} from '../Layer_images/Settings_images/google-maps.svg'
import {ReactComponent as Routing} from '../Layer_images/Settings_images/routing-right.svg'
import Checkbox from '@mui/material/Checkbox';
import { Card } from '@mui/material';
import SelectionBox from '../ui_components/SelectionBox';

const SettingsRightSide = ({handleStreetView, handleNavigation, handleSettingsChanged, showRadiusAll, showLocationNames, showLocationMarkers}) => {
    const [settingsShow, setSettingsShow] = useState(false);
    const [locationDistance, setLocationDistance] = useState(false);

    const handleNavigationPrimary = (event) => {
        const distanceType = event.target.value;
        setLocationDistance(false)
        handleNavigation(distanceType)
    }

    const layers = [
        { id: 'showRadiusAll', label: 'Toggle Radius', ind: showRadiusAll },
        { id: 'showLocationNames', label: 'Toggle Names', ind: showLocationNames },
        { id: 'showLocationMarkers', label: 'Toggle Markers', ind:  showLocationMarkers}
    ];

    const distanceValues = [
        {
            label: 'Shortest Distance Range',
            value: 'shortest'
        },
        {
            label: 'Fastest Travel Time',
            value: 'fastest'
        }
    ]

    return  <div>
                   
                <div className='mapboxgl-ctrl-top-right'>
                    <div className='mapboxgl-ctrl mapboxgl-ctrl-group'>
                    <button className="mapboxgl-ctrl-zoom-in display-inline-block border-right-light" type="button" aria-label="Zoom in" aria-disabled="false" onClick={() => setLocationDistance(true)}>
                    <Routing/>                    </button>
                    <button className="mapboxgl-ctrl-zoom-in display-inline-block border-right-light" type="button" aria-label="Zoom in" aria-disabled="false" onClick={ () => handleStreetView()}>
                    <Google_maps/>
                    </button>
                    <button className="mapboxgl-ctrl-zoom-in display-inline-block border-right-light" type="button" aria-label="Zoom in" aria-disabled="false" onClick={() => setSettingsShow(true)}>
                    <Sidebar_settings/>
                    </button>
                    </div>
                </div>


                <OutsideClickHandler onOutsideClick={() => setSettingsShow(false)}>
                    <div className={settingsShow ? 'settings-legend': 'settings-legend settings-legend-hide'}>
                    <div className="Building-title pl-15">Location Settings</div>
                    <Card sx={{ boxShadow: 'none', padding: 0, bgcolor: 'white' }}>
                        <div className="Building-total-each height-auto">
                        {layers.map(layer => (
                            <div 
                            key={layer.id}
                            className="layer-row"
                            onClick={() => handleSettingsChanged(layer.id)}
                            >
                            <Checkbox
                                size="small"
                                checked={layer.ind}
                                // onClick={(e) => e.stopPropagation()}
                            />
                            <span className="layer-label">{layer.label}</span>
                            </div>
                        ))}
                        </div>
                    </Card>
                    </div>
                </OutsideClickHandler>

                {/* <OutsideClickHandler onOutsideClick={() => setSettingsShow(false)}>
                    <div className={settingsShow ? 'settings-legend': 'settings-legend settings-legend-hide'}>
                        <div className="Building-title">Location Settings</div>
                        <div className="legend-main">
                            <div className="legend-opener">
                            <div
                                className={showRadiusAll ? 'legend-opener-eachclick legend-opener-each' : 'legend-opener-each'}
                                onClick={() => handleSettingsChanged('showRadiusAll')}
                            >
                                Toggle Radius
                            </div>
                            <div
                                className={showLocationNames ? 'legend-opener-eachclick legend-opener-each' : 'legend-opener-each'}
                                onClick={() => handleSettingsChanged('showLocationNames')}                           
                            >
                                Toggle Names
                            </div>
                            <div
                                className={showLocationMarkers ? 'legend-opener-eachclick legend-opener-each' : 'legend-opener-each'}
                                onClick={() => handleSettingsChanged('showLocationMarkers')}                           
                            >
                                Toggle Markers
                            </div>
                            
                            </div>
                        </div>
                    </div>
                </OutsideClickHandler> */}
                <OutsideClickHandler onOutsideClick={() => setLocationDistance(false)}>
                    <div className={locationDistance ? 'settings-legend top-55 width-192': 'settings-legend top-55 settings-legend-hide width-192'}>
                        <SelectionBox selectionName={'Distance Measurement'} selectionValue={null} selectionChecked={null} selectionSwitch={null} selectionChange={handleNavigationPrimary} selectionOptions={distanceValues}/>
                    </div>
                </OutsideClickHandler>

                {/* <OutsideClickHandler onOutsideClick={() => setLocationDistance(false)}>
                    <div className={locationDistance ? 'settings-legend top-10 width-192': 'settings-legend top-10 settings-legend-hide width-192'}>
                        <div className="Building-title">Location Settings</div>
                        <div  className='width-180 legend-main'>
                            <div className="legend-opener">
                            <div
                                className='legend-opener-each'
                                onClick={() => handleNavigationPrimary('shortest')}
                            >
                                Shortest Distance Range
                            </div>
                            <div
                                className= 'legend-opener-each'
                                onClick={() => handleNavigationPrimary('fastest')}                           
                            >
                                Fastest Travel Time
                            </div>
                            
                            </div>
                        </div>
                    </div>
                </OutsideClickHandler> */}

            </div>
}
export default SettingsRightSide;
